module.exports = __webpack_public_path__ + "static/img/logo_kr_01.24a645d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_kr_01.png
// module id = a3EF
// module chunks = 1